/* src/app/app.component.scss */
ks-main-content {
  margin-top: calc(var(--padding-top) + 29px);
}
/*# sourceMappingURL=app.component.css.map */
